// @ts-nocheck
import React from "react";
import { UploadIcon } from "../../assets/svgs";
import { PositionImage, Position } from "../../interfaces";
import { Dropzone, FileWithPath } from "@mantine/dropzone";
import { ACCEPT_FILE_TYPES } from "../AccountBulkUpload/AddImageCard";
import { BorderOutlined } from "@ant-design/icons";
import { BsBorder } from "react-icons/bs";
import { t } from "i18next";

type Props = {
  handleUpload: (files: FileWithPath[]) => void;
  item: Position;
  images: PositionImage[];
  disabled?: boolean;
};

const Upload: React.FC<Props> = ({
  handleUpload,
  images,
  item,
  disabled = false,
}) => {
  const inputRef: any = React.useRef(null);
  const sum = images.reduce(
    (acc: number, curr: PositionImage) => acc + curr.quantity,
    0
  );
  return sum < item.quantity ? (
    <Dropzone
      disabled={disabled}
      openRef={inputRef}
      accept={ACCEPT_FILE_TYPES}
      onDrop={handleUpload}
      maxFiles={1}
      multiple={false}
      className="w-auto cursor-pointer border-1 border-radius-4 p-0"
    >
      <div className="h-52 w-52 flex flex-col items-center justify-center">
        <div className="items-center justify-center">
          <UploadIcon />
        </div>
        <div className="items-center justify-center text-center">
          <div className="text-xs flex flex-col h-fit pt-2">
            <p
              className="text-xs font-bold underline "
              style={{ fontSize: "1rem", lineHeight: "1rem" }}
            >
              {t("chooseFile")}
            </p>
            <p
              className="text-xs font-bold"
              style={{ fontSize: "0.75rem", lineHeight: "0.75rem" }}
            >
              {t("orDrop")}
            </p>
            <p
              className="text-xs"
              style={{ fontSize: "0.75rem", lineHeight: "0.75rem" }}
            >
              {t("allowedFileformats")}
            </p>
          </div>
        </div>
      </div>
    </Dropzone>
  ) : (
    <div className="disabled" style={{border: "2px dashed", borderRadius: "32px"}}>
      <div className="h-52 w-52 flex flex-col items-center justify-center">
        <div className="items-center justify-center">
          <UploadIcon />
        </div>
        <div className="items-center justify-center text-center">
          <div className="text-xs flex flex-col h-fit pt-2">
            <p
              className="text-xs font-bold underline "
              style={{ fontSize: "1rem", lineHeight: "1rem" }}
            >
              {t("chooseFile")}
            </p>
            <p
              className="text-xs font-bold"
              style={{ fontSize: "0.75rem", lineHeight: "0.75rem" }}
            >
              {t("orDrop")}
            </p>
            <p
              className="text-xs"
              style={{ fontSize: "0.75rem", lineHeight: "0.75rem" }}
            >
              {t("allowedFileformats")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Upload;
